<main class="variable-dialog" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <!-- Header -->
    <div class="dialog-header" cdkDragHandle>
        <div class="header-left">
            <mat-icon class="header-icon">data_object</mat-icon>
            <h3>{{ data.mode === 'new' ? 'Add Variable' : 'Edit Variable' }}</h3>
        </div>
        <div class="header-actions">
            <button class="btn-copy-all" (click)="useEnValueForAll()" matTooltip="Apply EN value to all languages">
                <mat-icon>content_copy</mat-icon>
                <span>Copy EN to all</span>
            </button>
            <button class="btn-close-dialog" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="dialog-content">
        <form [formGroup]="variableForm" #varForm="ngForm">
            <!-- Variable Name -->
            <div class="field-group name-field">
                <label class="field-label">
                    Variable Name
                    @if (data.variable?.isSystemVariable) {
                    <span class="system-badge" matTooltip="This is a system-provided variable that is automatically available in all templates">
                        <mat-icon>lock</mat-icon>
                        System Variable
                    </span>
                    }
                </label>
                <mat-form-field appearance="outline" class="w-100" [class.has-value]="variableForm.value.name">
                    <mat-icon matPrefix>label</mat-icon>
                    <input matInput type="text" formControlName="name" name="riVariableName"
                        placeholder="e.g., userName, companyName" autocomplete="off" autocorrect="off"
                        autocapitalize="none" spellcheck="false"
                        [readonly]="data.variable?.isSystemVariable" />
                </mat-form-field>
                @if (data.variable?.isSystemVariable) {
                <p class="field-hint system-hint">
                    <mat-icon>info</mat-icon>
                    This variable is automatically provided by the system and available in all email templates. You can customize its sample values for preview purposes, but the variable name cannot be changed or deleted.
                </p>
                } @else {
                <p class="field-hint">Use in templates as
                    <code>{{ '{{' + (variableForm.value.name || 'variableName') + '}}' }}</code></p>
                }
            </div>

            <!-- Language Values -->
            <div class="field-group values-field">
                <label class="field-label">Values by Language</label>
                <div class="language-values" [formGroup]="valueGroup">
                    <div class="lang-value-row" *ngFor="let key of objectKeys(valueGroup.controls)"
                        [class.edited]="variableForm.value.value[key] !== varInitial.value[key]">
                        <span class="lang-code">{{ key.toUpperCase() }}</span>
                        <mat-form-field appearance="outline" class="lang-input">
                            <textarea matInput [formControlName]="key" [attr.name]="'riVariable'+key"
                                placeholder="Enter value for {{ key.toUpperCase() }}..." cdkTextareaAutosize
                                #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                                cdkAutosizeMaxRows="5"></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
        <div class="footer-left">
            <button *ngIf="data.mode === 'edit' && !data.variable?.isSystemVariable" class="btn-delete" (click)="update(true)">
                <mat-icon>delete_outline</mat-icon>
                <span>Delete</span>
            </button>
        </div>
        <div class="footer-right">
            <button class="btn-reset" (click)="reset()" [disabled]="!hasChanges()">
                <mat-icon>refresh</mat-icon>
                <span>Reset</span>
            </button>
            <button class="btn-save" (click)="update()" [disabled]="!hasChanges() || variableForm.invalid">
                <mat-icon>check</mat-icon>
                <span>{{ data.mode === 'new' ? 'Add Variable' : 'Save Changes' }}</span>
            </button>
        </div>
    </div>
</main>
